import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-details-view',
  templateUrl: './org-details-view.component.html',
  styleUrls: ['./org-details-view.component.scss']
})
export class OrgDetailsViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
